import { patch } from "@src/appV2/api";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import {
  workerStatusRequestSchema,
  type WorkerStatusResponse,
  workerStatusResponseSchema,
} from "../types";
import {
  getWorkerHomeHealthEnabledQueryKey,
  getWorkerHomeHealthEnabledUrl,
} from "./useIsWorkerHomeHealthEnabled";

export function useUpdateHomeHealthWorkerStatus(
  workerId: string,
  options: UseMutationOptions<WorkerStatusResponse, unknown, boolean> = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newStatus: boolean) => {
      const response = await patch({
        url: getWorkerHomeHealthEnabledUrl(workerId),
        data: {
          data: {
            type: "worker",
            attributes: {
              homeHealthEnabled: newStatus,
            },
          },
        },
        responseSchema: workerStatusResponseSchema,
        requestSchema: workerStatusRequestSchema,
      });
      return response.data;
    },
    onSuccess: (data) => {
      queryClient.setQueryData(getWorkerHomeHealthEnabledQueryKey(workerId), data);
    },
    ...options,
  });
}
